import api from "./api";

/**
 * Hizmet uçları (backend: /api/services). Yanıtlar ApiResponse zarfında
 * (res.data.data); liste Spring Pageable döner.
 */
export const serviceService = {
  list: (params = {}) => api.get("/services", { params }),
  get: (id) => api.get(`/services/${id}`),
  create: (payload) => api.post("/services", payload),
  update: (id, payload) => api.put(`/services/${id}`, payload),
  remove: (id) => api.delete(`/services/${id}`), // soft delete (pasife al)
  hardRemove: (id) => api.delete(`/services/${id}`, { params: { hard: true } }),
  setActive: (id, active) => api.patch(`/services/${id}/status`, null, { params: { active } }),
};
